import React from 'react';
import {Trans} from "@lingui/macro";

export function ReadOnlyBox(props) {
    const { children, className, disabled, placeholder } = props;

    const newClassName = className + (disabled ? ' ant-input-disabled' : '');

    return (
        <div
            className={`ant-input ant-custom-readonly ${newClassName}`}
        >
            { !children ? (
                <span className="placeholder">
                    {placeholder}
                </span>
            ) : children }
        </div>
    );
}

ReadOnlyBox.defaultProps = {
    className: '',
};
